import { render, staticRenderFns } from "./ComPopup.vue?vue&type=template&id=16afdd2d&"
import script from "./ComPopup.vue?vue&type=script&lang=js&"
export * from "./ComPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports